import { useCallback, useMemo, useState } from "react";
import { blankLoanForm, loanCalculations } from "../lib/loanForm";

const REQUIRED_LOAN_FIELDS = [
  "loan_amount",
  "interest_amount",
  "deposit_amount",
  "stamp_duty",
  "loan_date",
  "term_days",
  "remarks",
];

export const useLoanForm = () => {
  const [form, setForm] = useState(blankLoanForm);
  const [submitted, setSubmitted] = useState(false);
  const [saving, setSaving] = useState(false);

  const update = useCallback((field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  }, []);

  const reset = useCallback(() => {
    setForm(blankLoanForm());
    setSubmitted(false);
    setSaving(false);
  }, []);

  const calculations = useMemo(() => loanCalculations(form), [form]);

  const isInvalid = useCallback((field) => {
    return submitted && (!form[field] || Number(form[field]) < 0);
  }, [form, submitted]);

  const isComplete = useCallback(() => {
    return REQUIRED_LOAN_FIELDS.every((field) => form[field] !== "")
      && Number(form.loan_amount) > 0
      && Number(form.term_days) > 0;
  }, [form]);

  return {
    calculations,
    form,
    isComplete,
    isInvalid,
    reset,
    saving,
    setSaving,
    setSubmitted,
    submitted,
    update,
  };
};